import { Feature } from '@occc/utils-access-control';
import {
  SegmentCreatePage as SegmentV1CreatePage,
  SegmentDetailsPage as SegmentV1DetailsPage,
  SegmentListPage as SegmentV1ListPage,
} from '@occc-app/routes/Segment';
import { routeCreator as segmentV1RouteCreator } from '@occc-app/routes/Segment/utils';
import { SegmentsVersion } from '@occc/config';

import { SegmentsParts } from './segments.factory.types';

import { SegmentListPage as SegmentV2ListPage } from '../features/segment-list-page/segment-list.page';
import { SegmentCreateController as SegmentV2CreatePage } from '../features/segment-create-page/segment-create.controller';
import { SegmentDetailsController as SegmentV2DetailsPage } from '../features/segment-details-page/segment-details.controller';
import { routeCreator as segmentV2RouteCreator } from '../segments.router';

const versionToSegmentsMap: Record<SegmentsVersion, SegmentsParts> = {
  '1': {
    routes: [
      {
        path: segmentV1RouteCreator.base(),
        feature: Feature.SEGMENTS_VIEW,
        component: SegmentV1ListPage,
      },
      {
        path: segmentV1RouteCreator.create(),
        feature: Feature.SEGMENT_CREATE,
        component: SegmentV1CreatePage,
      },
      {
        path: segmentV1RouteCreator.details(':id'),
        feature: Feature.SEGMENT_VIEW,
        component: SegmentV1DetailsPage,
      },
    ],
  },
  '2': {
    routes: [
      {
        path: segmentV2RouteCreator.list(),
        feature: Feature.SEGMENTS_VIEW,
        component: SegmentV2ListPage,
      },
      {
        path: segmentV2RouteCreator.create(),
        feature: Feature.SEGMENT_CREATE,
        component: SegmentV2CreatePage,
      },
      {
        path: segmentV2RouteCreator.details(':uuid'),
        feature: Feature.SEGMENT_VIEW,
        component: SegmentV2DetailsPage,
      },
    ],
  },
};

export const segmentsFactory = (version: SegmentsVersion): SegmentsParts =>
  versionToSegmentsMap[version];
